import Contact from "./Contact"
import Socials from "./Socials"
function Footer() {
    return (<div>
        <Contact />
        <Socials location={"footer"}/>
    </div>)
}

export default Footer